export const APP_LANGUAGE_STORAGE_KEY = 'appLanguage';

export const SUPPORTED_APP_LANGUAGES = ['en', 'mm'];

export const normalizeAppLanguage = (language) => (
    SUPPORTED_APP_LANGUAGES.includes(language) ? language : 'en'
);

export const getLocaleFromLanguage = (language) => (
    normalizeAppLanguage(language) === 'mm' ? 'my-MM' : 'en-US'
);

export const getDocumentLanguage = (language) => (
    normalizeAppLanguage(language) === 'mm' ? 'my' : 'en'
);

export const getStoredAppLanguage = () => {
    if (typeof window === 'undefined') return 'en';

    try {
        return normalizeAppLanguage(window.localStorage.getItem(APP_LANGUAGE_STORAGE_KEY));
    } catch (error) {
        return 'en';
    }
};
